// extracted by mini-css-extract-plugin
export default {"title":"Title_title__IlEm8","titleContainer":"Title_titleContainer__pfs7i","rightChildren":"Title_rightChildren__vxZQF"};